import React, { useState } from "react"
import {
  Tabs as ReactTabs,
  TabList as ReactTabList,
  Tab as ReactTab,
  TabPanel,
} from "react-tabs"
import "react-tabs/style/react-tabs.css"

import styles from "./index.module.scss"

function TabList(props) {
  const { children, className, ...rest } = props

  const cClasses = `${styles.tabList} ${className ? className : ""}`

  return (
    <ReactTabList className={cClasses} {...rest}>
      {children}
    </ReactTabList>
  )
}

TabList.tabsRole = "TabList"

function Tab(props) {
  const { children, disabled, ...rest } = props

  const cClass = `${styles.tab} `

  return (
    <ReactTab
      className={`${disabled ? styles.disabledTab : cClass}`}
      {...rest}
      disabled={disabled}
    >
      {children}
    </ReactTab>
  )
}

Tab.tabsRole = "Tab"

function MainTabs(props) {
  const { children, ...rest } = props

  return <ReactTabs {...rest}>{children}</ReactTabs>
}

const Tabs = Object.assign(MainTabs, { TabList, Tab, TabPanel })

export default Tabs
